import React, { Component } from 'react';
import LayoutHeader from '../Inc/Header';
import AdminNavigation from '../Inc/AdminNavigation';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import "./style.css";
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { DatePicker, Button, Typography, Tabs, Table, Divider, Spin, Modal, Upload, Icon, message, Row, Col, Input, Form, Card } from 'antd';
import { history } from '../../container/History';
import NESAFileFormat from './NESAmembership.csv';
const { Text } = Typography;
const { Dragger } = Upload;
const FormItem = Form.Item;

class AdminBulkUpload extends React.Component {

  state = {
    fileList: [],
  };

  handleUpload = () => {
    const { fileList } = this.state;
    const formData = new FormData();
    fileList.forEach(file => {
      formData.append('file', file);
    });

    this.props.actions.adminBulkUpload(formData)
  };



  componentWillReceiveProps = (nextprops) => {
    if (this.props.loaded !== nextprops.loaded) {
      this.setState({
        fileList: []
      })
    }
  }


  render() {
    const { fileList } = this.state;
    const props = {
      onRemove: file => {
        this.setState(state => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState(state => ({
          fileList: [...state.fileList, file],
        }));
        return false;
      },
      fileList,
    };

    return (
      <div>
        <LayoutHeader />

        <AdminNavigation />

        <div className="step-widget bulk-upload">

          <Row>
            <Col className="card-margin" xs={24} sm={24} md={24} lg={24} xl={24}>
              <Card className="centered" title="NESA Bulk Upload Membership" extra={<a href={NESAFileFormat} className='download-format-btn' download="nesa.csv"> <Icon type="download" /> Download Format</a>}>
                <Divider orientation="left">Note</Divider>
                <Text>
                Please upload the CSV files in the correct format. You can download the format file from the "Download Format" button above.
                   </Text>

                <Divider></Divider>
                <div style={{ margin: '20px' }} className="actionBtn centered m-t-10">
                  <div>
                    <Row type='flex' align='middle' justify='center'>
                      <Upload {...props} multiple='false'>
                        <Button>
                          <Icon type="upload" /> Select File
                           </Button>
                      </Upload>
                    </Row>
                  </div>
                </div>


                <div style={{ margin: '20px' }} className="actionBtn centered m-t-10">
                  <div>
                    <Row type='flex' align='middle' justify='space-around'>
                      <Col
                        className="xs-center sm-center"
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        xl={12}
                      >


                      </Col>
                      <Col
                        className="xs-center right sm-center"
                        xs={24}
                        sm={24}
                        md={12}
                        lg={12}
                        xl={12}
                      >
                        <Button
                          type="primary"
                          size='large'
                          onClick={this.handleUpload}
                          disabled={fileList.length === 0 && fileList.length === 1}
                          loading={this.props.loading}
                          style={{ marginTop: 16 }}
                        >
                          {this.props.loading ? 'Uploading' : <span> < Icon type="upload" /> Upload </span>}
                        </Button>
                      </Col>
                    </Row>
                  </div>
                </div>


              </Card>
            </Col>
          </Row>

        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    loading: state.bulkuploadreducer.profileinfo,
    loaded: state.bulkuploadreducer.response,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AdminBulkUpload);



// WEBPACK FOOTER //
// ./src/components/BulkUpload/admin.js